<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
	<h6 mat-dialog-title class="grey1">{{ data.sysText.duplicateDetected_header | titlecase }}</h6>
	@if (isMobile$ | async) {
		<span class="spacer"></span>
		<button type="button" class="button-reset" [mat-dialog-close]="false" [aria-label]="data.sysText.duplicateDetected_cancel" [disabled]="isSubmitting$ | async">
			<mat-icon class="button-icon">close</mat-icon>
		</button>
	}
</div>

<mat-dialog-content>
	<p>{{ data.duplicateDetectedDialog.employeeDuplicatesFound ? data.sysText.duplicateDetected_employeeMessage2 : data.sysText.duplicateDetected_caseMessage }}</p>

	<!-- Duplicate Employees -->
	@if (data.duplicateDetectedDialog.employeeDuplicatesFound) {
		@for (duplicateEmployeesFound of data.duplicateDetectedDialog.employeeDuplicatesFound; track duplicateEmployeesFound; let i = $index) {
			<div class="border-box">
				<div class="section-info-container">
					<p class="body2 grey2 overline">{{ data.sysText.duplicateDetected_youEntered | uppercase }}:</p>
					<div class="name-section">
						<h6 class="grey1 bullet-spacing">{{ duplicateEmployeesFound.postEmployeeInfo.fullName }}</h6><span class="bullet-spacing">&bull;</span><p>{{ duplicateEmployeesFound.postEmployeeInfo.company }}</p>
					</div>
					<div class="info-row">
						<div class="tile-label-container info-spacing" >
							<p class="body2 grey2 ellipsis">{{ data.sysText.workEmail | titlecase }}</p>
						</div>
						<p class="body2 grey1 semibold ellipsis">{{ duplicateEmployeesFound.postEmployeeInfo.workEmail ?? "--" }}</p>
					</div>
					<div class="info-row">
						<div class="tile-label-container info-spacing" >
							<p class="body2 grey2 ellipsis">{{ data.sysText.personalEmail | titlecase }}</p>
						</div>
						<p class="body2 grey1 semibold ellipsis">{{ duplicateEmployeesFound.postEmployeeInfo.personalEmail ?? "--" }}</p>
					</div>
					<div class="info-row">
						<div class="tile-label-container info-spacing" >
							<p class="body2 grey2 ellipsis">{{ data.sysText.workPhone | titlecase }}</p>
						</div>
						<p class="body2 grey1 semibold ellipsis">{{ duplicateEmployeesFound.postEmployeeInfo.workPhone ?? "--" }}</p>
					</div>
					<div class="info-row">
						<div class="tile-label-container info-spacing" >
							<p class="body2 grey2 ellipsis">{{ data.sysText.personalPhone | titlecase }}</p>
						</div>
						<p class="body2 grey1 semibold ellipsis">{{ duplicateEmployeesFound.postEmployeeInfo.personalPhone ?? "--" }}</p>
					</div>
					<div class="info-row">
						<div class="tile-label-container info-spacing" >
							<p class="body2 grey2 ellipsis">{{ data.sysText.jobTitle | titlecase}}</p>
						</div>
						<p class="body2 grey1 semibold ellipsis">{{ duplicateEmployeesFound.postEmployeeInfo.jobTitle ?? "--"}}</p>
					</div>
					<div class="info-row">
						<div class="tile-label-container info-spacing" >
							<p class="body2 grey2 ellipsis">{{ data.sysText.employeeType | titlecase}}</p>
						</div>
						<p class="body2 grey1 semibold ellipsis">{{ duplicateEmployeesFound.postEmployeeInfo.employeeType ?? "--"}}</p>
					</div>
					<div class="info-row">
						<div class="tile-label-container info-spacing" >
							<p class="body2 grey2 ellipsis">{{ data.sysText.payType | titlecase}}</p>
						</div>
						<p class="body2 grey1 semibold ellipsis">{{ duplicateEmployeesFound.postEmployeeInfo.payType ?? "--"}}</p>
					</div>
					<div class="info-row">
						<div class="tile-label-container info-spacing" >
							<p class="body2 grey2 ellipsis">{{ data.sysText.supervisors | titlecase}}</p>
						</div>
						@if (!(duplicateEmployeesFound.postEmployeeInfo.supervisors?.length > 0)) {
							<p class="body2 grey1 semibold">--</p>
						} @else {
							<span class="ellipsis">
								@for (superv of duplicateEmployeesFound.postEmployeeInfo.supervisors; track superv) {
									<p class="body2 grey1 semibold ellipsis align-left">{{ superv}}</p>
								}
							</span>
						}
					</div>
				</div>
			</div>
			<div class="border-box">
				<p class="body2 grey2 overline">{{ data.sysText.duplicateDetected_potentialDuplicates | uppercase}}:</p>
				@for (duplicateEmployee of duplicateEmployeesFound.duplicateEmployeesFound; track duplicateEmployee; let i = $index) {
					<div class="section-info-container  margin-bottom">
						<div class="name-section">
							<h6 class="grey1 bullet-spacing">{{ duplicateEmployee.fullName }}</h6><span class="bullet-spacing">&bull;</span><p>{{ duplicateEmployee.company }}</p>
						</div>
						<div class="info-row">
							<div class="tile-label-container info-spacing" >
								<p class="body2 grey2 ellipsis">{{ data.sysText.workEmail | titlecase }}</p>
							</div>
							<p class="body2 grey1 semibold ellipsis">{{ duplicateEmployee.workEmail ?? "--" }}</p>
						</div>
						<div class="info-row">
							<div class="tile-label-container info-spacing" >
								<p class="body2 grey2 ellipsis">{{ data.sysText.personalEmail | titlecase }}</p>
							</div>
							<p class="body2 grey1 semibold ellipsis">{{ duplicateEmployee.personalEmail ?? "--" }}</p>
						</div>
						<div class="info-row">
							<div class="tile-label-container info-spacing" >
								<p class="body2 grey2 ellipsis">{{ data.sysText.workPhone | titlecase }}</p>
							</div>
							<p class="body2 grey1 semibold ellipsis">{{ duplicateEmployee.workPhone ?? "--" }}</p>
						</div>
						<div class="info-row">
							<div class="tile-label-container info-spacing" >
								<p class="body2 grey2 ellipsis">{{ data.sysText.personalPhone | titlecase }}</p>
							</div>
							<p class="body2 grey1 semibold ellipsis">{{ duplicateEmployee.personalPhone ?? "--" }}</p>
						</div>
						<div class="info-row">
							<div class="tile-label-container info-spacing" >
								<p class="body2 grey2 ellipsis">{{ data.sysText.jobTitle | titlecase }}</p>
							</div>
							<p class="body2 grey1 semibold ellipsis">{{ duplicateEmployee.jobTitle ?? "--" }}</p>
						</div>
						<div class="info-row">
							<div class="tile-label-container info-spacing" >
								<p class="body2 grey2 ellipsis">{{ data.sysText.employeeType | titlecase }}</p>
							</div>
							<p class="body2 grey1 semibold ellipsis">{{ duplicateEmployee.employeeType ?? "--" }}</p>
						</div>
						<div class="info-row">
							<div class="tile-label-container info-spacing" >
								<p class="body2 grey2 ellipsis">{{ data.sysText.payType | titlecase }}</p>
							</div>
							<p class="body2 grey1 semibold ellipsis">{{ duplicateEmployee.payType ?? "--" }}</p>
						</div>
						<div class="info-row">
							<div class="tile-label-container info-spacing" >
								<p class="body2 grey2 ellipsis">{{ data.sysText.supervisors | titlecase }}</p>
							</div>
							@if (!(duplicateEmployee.supervisors?.length > 0)) {
								<p class="body2 grey1 semibold">--</p>
							} @else {
								<span class="ellipsis">
									@for (superv of duplicateEmployee.supervisors; track superv) {
										<p class="body2 grey1 semibold ellipsis align-left">{{superv }}</p>
									}
								</span>
							}
						</div>
					</div>
				}
			</div>
			@if (i != data.duplicateDetectedDialog.employeeDuplicatesFound.length - 1) {
				<mat-divider class="section-underline"></mat-divider>
			}
		}
	} @else {
		<!-- Duplicate Cases -->
		<div class="border-box">
			<div class="section-info-container">
				<p class="body2 grey2 overline">{{ data.sysText.duplicateDetected_youEntered | uppercase}}:</p>
				<div class="name-section">
					<h6 class="grey1 bullet-spacing">{{ data.duplicateDetectedDialog.caseDuplicatesFound.postCaseInfo.fullName }}</h6><span class="bullet-spacing">&bull;</span><p>{{ data.duplicateDetectedDialog.caseDuplicatesFound.postCaseInfo.company}}</p>
				</div>
				<div class="info-row">
					<div class="tile-label-container info-spacing" >
						<p class="body2 grey2 ellipsis">{{ data.sysText.leaveReason | titlecase }}</p>
					</div>
					<p class="body2 grey1 semibold ellipsis">{{  data.duplicateDetectedDialog.caseDuplicatesFound.postCaseInfo.leaveReason }}</p>
				</div>
				<div class="info-row">
					<div class="tile-label-container info-spacing" >
						<p class="body2 grey2 ellipsis">{{ data.sysText.requestedStartDate | titlecase}}</p>
					</div>
					<p class="body2 grey1 semibold ellipsis">{{ data.duplicateDetectedDialog.caseDuplicatesFound.postCaseInfo.requestedStartDate | date }}</p>
				</div>
			</div>
		</div>
		<div class="border-box">
			<p class="body2 grey2 overline">{{ data.sysText.duplicateDetected_potentialDuplicates | uppercase }}:</p>
			@for (duplicateCase of data.duplicateDetectedDialog.caseDuplicatesFound.duplicateCasesFound; track duplicateCase; let i = $index) {
				<div class="section-info-container  margin-bottom">
					<div class="name-section">
						<h6 class="grey1 bullet-spacing">{{ duplicateCase.fullName }}</h6><span class="bullet-spacing">&bull;</span><p>{{duplicateCase.company}}</p>
					</div>
					<div class="info-row">
						<div class="tile-label-container info-spacing" >
							<p class="body2 grey2 ellipsis">{{data.sysText.caseId | titlecase }}</p>
						</div>
						<p class="body2 grey1 semibold ellipsis">{{ duplicateCase.caseId }}</p>
					</div>
					<div class="info-row">
						<div class="tile-label-container info-spacing" >
							<p class="body2 grey2 ellipsis">{{data.sysText.leaveReason | titlecase }}</p>
						</div>
						<p class="body2 grey1 semibold ellipsis">{{ duplicateCase.leaveReason }}</p>
					</div>
					<div class="info-row">
						<div class="tile-label-container info-spacing" >
							<p class="body2 grey2 ellipsis">{{ data.sysText.dateReceived | titlecase }}</p>
						</div>
						<p class="body2 grey1 semibold ellipsis">{{ duplicateCase.dateReceived | date }}</p>
					</div>
					@if (duplicateCase.startDate) {
						<div class="info-row">
							<div class="tile-label-container info-spacing" >
								<p class="body2 grey2 ellipsis">{{data.sysText.startDate | titlecase }}</p>
							</div>
							<p class="body2 grey1 semibold ellipsis">{{ duplicateCase.startDate | date }}</p>
						</div>
					}
					@if (duplicateCase.requestedStartDate) {
						<div class="info-row">
							<div class="tile-label-container info-spacing" >
								<p class="body2 grey2 ellipsis">{{ data.sysText.requestedStartDate | titlecase }}</p>
							</div>
							<p class="body2 grey1 semibold ellipsis">{{ duplicateCase.requestedStartDate | date }}</p>
						</div>
					}
				</div>
			}
		</div>
	}

	<p class="bottom-message">{{ data.duplicateDetectedDialog.employeeDuplicatesFound ? data.sysText.duplicateDetected_employeeMessage2 : data.sysText.duplicateDetected_caseMessage2}}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
	@if (!(isSubmitting$ | async)) {
		@if (!(isMobile$ | async)) {
			<button mat-stroked-button class="button" color="accent" [mat-dialog-close]="false" [disabled]="isSubmitting$ | async">
				{{ data.sysText.duplicateDetected_cancel }}
			</button>
		}
		<button mat-stroked-button class="button" color="accent" [mat-dialog-close]="true" [disabled]="(isSubmitting$ | async)">
			{{ data.sysText.duplicateDetected_save }}
		</button>
	} @else {
		<button mat-button class="button" type="button" color="accent" disabled>
			<mat-spinner diameter="30" color="accent"></mat-spinner>
		</button>
	}
</mat-dialog-actions>